import type { FormSchema, GeneratorOptions } from '@cli-types/core-engine/schema.js'
import type { StepResult } from '@cli-types/next-adapter/forms.js'
import { createGeneratedFile } from '@cli-utils/files.js'
import { toCamelCase, toKebabCase, toPascalCase } from '@cli-utils/text.js'
import { resolveSchemaActionImportPath } from '@next-adapter/config/paths/resolve-schema-action-import-path.js'
import { renderFormPipelineFormHookRenderer } from '@next-adapter/templates/renderers/generators/form-pipeline/form-hook.js'

export function generateFormHook(
  schema: FormSchema,
  hooksDir: string,
  options: GeneratorOptions
): StepResult {
  const actionImportPath = resolveSchemaActionImportPath(schema.name, options.outputNamespace)
  const formName = schema.name
  const pascal = toPascalCase(formName)
  const camel = toCamelCase(formName)
  const kebab = toKebabCase(formName)
  const successMsg = (schema.successMessage || 'Form submitted successfully').replace(/'/g, "\\'")
  const hasExport = schema.actions?.export === true

  const submissionActionImports = [
    `create${pascal}Submission,`,
    `delete${pascal}Submission,`,
    hasExport ? `export${pascal}SubmissionsCSV,` : null,
    `get${pascal}Submission,`,
    `get${pascal}Submissions,`
  ]
    .filter((line): line is string => line !== null)
    .map((line) => `  ${line}`)
    .join('\n')

  const content = renderFormPipelineFormHookRenderer({
    kind: 'renderFormHookGeneratedFunctionTemplate',
    props: {
      submissionActionImports: submissionActionImports,
      actionImportPath: actionImportPath,
      pascal: pascal,
      camel: camel,
      successMsg: successMsg,
      hasExportCreateObjectUrl: hasExport
        ? renderFormPipelineFormHookRenderer({
            kind: 'renderFormHookGeneratedFunctionDetailsTemplate',
            props: {
              pascal: pascal,
              formName: formName
            }
          })
        : ''
    }
  })

  return {
    files: [createGeneratedFile(`${hooksDir}/use-${kebab}-form.ts`, content)]
  }
}
